import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";
import { store } from "../../store";
export default function* watcherAddLocationSaga() {
  yield takeEvery("ADD_LOCATION", workerSaga);
  console.log("Check Loogger");
}

function* workerSaga(action) {
  try {
    yield put({ type: "DISPLAY_LOADER" });
    let payload = {};
    yield request("post", action.payload, "api/Admin/add-location").then(
      (response) => {
        payload = response;
      }
    );

    toast.success(payload);
    var formatUrl =
      "api/Admin/get-Locations/" + store.getState().persistReducer.companyId;
    yield request("get", action.payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "LOCATIONS_LIST", payload: payload });
    formatUrl = "api/Admin/locationTypes-dropdown";
    yield request("get", action.payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "LOCATION_TYPE_DROPDOWN_LIST", payload: payload });
    yield request("get", payload, "api/Admin/get-countries-dropdown").then(
      (response) => {
        payload = response;
      }
    );
    yield put({ type: "COUNTRIES_DROPDOWN", payload: payload });
    yield request(
      "get",
      action.payload,
      "/api/Admin/get-location-count?companyId=" +
        store.getState().persistReducer.companyId
    ).then((response) => {
      payload = response;
    });
    var locations = payload.locations;
    localStorage.setItem("locations", locations);
    yield put({ type: "DISPLAY_LOADER" });
  } catch (e) {
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    console.log("add-location-saga", e);
    yield put({ type: "DISPLAY_LOADER" });
    console.log("add-location-saga", e.response);
    console.log(e.response);
    console.log(e.response);
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
  }
}
